import { QueryClient } from '@tanstack/react-query-v5';
export const queryClientV5 = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            gcTime: 0,
            staleTime: 0,
            retry: 1
        }
    }
});
